(function (angular) {
    'use strict';

    angular.module('app.purchase').controller('app.purchase.PrimaryInformationController', [
        '$uibModalInstance',
        'states',
        'applicants',
        'primary',
        function ($uibModalInstance, states, applicants, primary) {
            var vm = this;
            vm.states = states;
            vm.modalTitle = '';
            vm.hidePassword = true;
            vm.confirmPassword = '';
            vm.hideConfirmPassword = true;
            vm.applicants = applicants;
            vm.primary = primary;
            vm.hasPrimary =
                vm.primary &&
                vm.primary !== null &&
                vm.primary.birthDate &&
                vm.primary.birthDate !== null &&
                vm.primary.birthDate !== '';
            vm.noMatch = noMatch;
            vm.continueToPayment = continueToPayment;
            vm.selectPrimary = selectPrimary;
            vm.setPrimary = setPrimary;
            vm.back = back;
            vm.cancel = cancel;

            if (vm.hasPrimary) {
                vm.modalTitle = 'Plan Holder Information';
            } else {
                vm.modalTitle = 'Select Plan Holder';
                vm.primary = vm.applicants[0];
            }

            vm.togglePassword = function () {
                vm.hidePassword = !vm.hidePassword;
            };

            vm.toggleConfirmPassword = function () {
                vm.hideConfirmPassword = !vm.hideConfirmPassword;
            };

            function noMatch() {
                return !(vm.primary.password === vm.confirmPassword);
            }

            function selectPrimary(user) {
                vm.primary = user;
            }

            function setPrimary() {
                vm.hasPrimary =
                    vm.primary &&
                    vm.primary !== null &&
                    vm.primary.birthDate &&
                    vm.primary.birthDate !== null &&
                    vm.primary.birthDate !== '';
                vm.modalTitle = 'Plan Holder Information';
            }

            function continueToPayment() {
                $uibModalInstance.close(vm.primary);
            }

            function back() {
                vm.modalTitle = 'Select Plan Holder';
                vm.hasPrimary = false;
            }

            function cancel() {
                $uibModalInstance.close();
            }
        }
    ]);
})(angular);
